export default {
    components: {},
};
